import styled from 'styled-components';
import theme from '../../styles/theme';

const StWordpressRaw = styled.div`
	figure{
		margin: 0 auto;
		max-width: ${theme.maxWidth};
		figcaption{
			display: inline;
		}
		.figwrap {
			display: block;
			font-size: 0.75rem;
			text-transform: uppercase;
			margin-block-start: 0.2rem;
			&:before{
				content: "▲";
			}
		}
	}

	h1{
		font-size: 3rem;
	}
	h2{
		font-size: 2.8rem;
	}
	h3{
		font-size: 2.6rem;
	}
	h4{
		font-size: 2.4rem;
	}
	h5{
		font-size: 2.2rem;
	}
	h6{
		font-size: 2rem;
	}

	h1,h2,h3,h4,h5,h6{
		max-width: ${theme.normalWidth};
		margin-left: auto;
		margin-right: auto;
		font-family: ${theme.fonttitle};
		padding-left: 1rem;
		padding-right: 1rem;
	}

	p{
		max-width: ${theme.normalWidth};
		margin-left: auto;
		margin-right: auto;
		font-size: ${theme.fontsize};
		line-height: ${theme.lineheight};
		text-align: left;
		padding-left: 1rem;
		padding-right: 1rem;
		&.has-drop-cap {
			&:first-letter {
				float: left;
				font-family: ${theme.fonttitle};
				/* color: ${theme.accent}; */
				font-size: 7.9rem;
				line-height: 4.2rem;
				padding-top: 1.9rem;
				padding-right: 4px;
				padding-left: 3px;
				font-style: normal;
			}
		}
		@media(max-width: 800px){
			font-size: 1.4rem;
		}
	}

	.wp-block-separator {
		border-color: ${theme.accent};
		max-width: ${theme.normalWidth};
	}

	ul {
		max-width: ${theme.normalWidth};
		margin-left: auto;
		margin-right: auto;
		padding: 0 1rem 0 2rem;
	}

	blockquote {
		padding: 2rem;
		margin-left: auto;
		margin-right: auto;
		max-width: calc(${theme.normalWidth} + 4rem);
		background-size: cover;

    font-weight: 600;
    /* background-position:  bottom; */
    background-repeat: no-repeat;
    text-align: right;

		@media (max-width: 800px) {
			margin-left: 1rem;
			margin-right: 1rem;
			padding: 0.6rem;
		}

    cite {
  		font-size: calc(${theme.fonttitlesize} / 4);
      text-align: left;
      font-weight: 600;
      font-family: ${theme.fonttitle3};
      margin: auto;
    }
		p {
      text-align: center;
			font-family: ${theme.fonttitle3};
			font-size: calc(${theme.fonttitlesize} / 3);
			line-height: calc(${theme.fonttitlesize} / 2);
			/* font-style: italic; */
			strong {
				color: ${theme.accent};
				font-size: calc(${theme.fonttitlesize} / 1);
			}
		}
	}

	video{
		max-width: ${theme.maxWidth};
		margin-left: auto;
		margin-right: auto;
		@media(max-width: 800px){
			margin-left: -1rem;
			margin-right: -1rem;
		}
	}



`

const CoreColumnBlock = styled.div`
  max-width: none;
`

const CoreColumns = styled.div`
	display: grid;
	height: ${props => props.height || 'auto'};
	grid-template-columns: ${props => props.gridtemplatecolumns || 'repeat(2, 1fr)'};
	max-width: ${theme.maxWidth};
	margin-left: auto;
	margin-right: auto;
	grid-gap: 2rem;
	align-items: flex-start;
	transform: translate3d(0px, 0px, 0px);
	padding: 0 1rem;
	margin-block-end: 10vh;
	&:last-of-type{
		margin-block-end: 80vh;
	}
	@media(max-width: 800px){
		grid-gap: 1rem;
		grid-template-columns: 120px 1fr;
	}
	.col{
		&:first-of-type{
			position: sticky;
			top: 20vh;
			display: flex;
			align-items: flex-end;
			flex-direction: column;
			figure{
				width: 80px;
				height: 80px;
				margin-bottom: 0.5rem;
			}
		}
	}
	.col{
		&:last-of-type{
			padding-top: 40vh;
			/* padding-bottom: 20vh; */
		}
	}
`;

export { StWordpressRaw, CoreColumnBlock, CoreColumns};
